import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4d2ed750&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=4d2ed750&prod&lang=less"
import style1 from "./detail.vue?vue&type=style&index=1&id=4d2ed750&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ed750",
  null
  
)

export default component.exports